import PropTypes from 'prop-types';
import React from 'react';
import { StyledFormField } from './StyledComponents';

/**
 * FormField - A wrapper for form fields with consistent spacing
 *
 * @param {React.ReactNode} children - The form field content
 * @param {boolean} fullWidth - Whether the field should span all grid columns
 * @param {string} className - Additional CSS classes
 */
const FormField = ({ children, fullWidth = false, className, ...props }) => {
  const classes = [className, fullWidth ? 'full-width' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <StyledFormField className={classes} {...props}>
      {children}
    </StyledFormField>
  );
};

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default FormField;
